// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Re-render the Recurse Center recurse-scout badge after client-side route
// changes. The loader only runs render() on the initial page load, so without
// this the badge would not re-populate the footer's `.rc-scout` element when
// navigating between pages client-side.
export const onRouteUpdate = () => {
  if (typeof window !== "undefined" && window._rcs && window._rcs.inst) {
    window._rcs.inst.render()
  }
}
